import { DatePipe } from '@angular/common';
import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { map, takeUntil } from 'rxjs';
import { TramDoGiaTriDoService } from 'src/app/thmp-monitoring/services/tram-do-gia-tri-do.service';
import { TramDoYeuToDoService } from 'src/app/thmp-monitoring/services/tram-do-yeu-to-do.service';
import { TramDoService } from 'src/app/thmp-monitoring/services/tram-do.service';
import { ExportService, SecondPageIndexBase } from 'sv-shared';
import * as XLSX from "xlsx";

@Component({
  selector: 'app-tramdo-report',
  templateUrl: './tramdo-report.component.html',
  styleUrls: ['./tramdo-report.component.css']
})
export class TramdoReportComponent extends SecondPageIndexBase implements OnInit {

  idTramDo = 0;
  itemDetail = { id: 0, title: '', address: '' }
  listTramDoYeuToDo = [];
  monthReport = new Date();
  idDmYeuToDo = 0;
  optionDmYeuTodo = [];


  tuNgay: Date;
  denNgay: Date;
  @ViewChild("tblData") tblData: ElementRef;
  cols1 = [];
  dataSourceMonth = [];
  dataExportMonth = [];

  listTramDo = [];
  selectedItem = 0;

  constructor(
    private _tramDoService: TramDoService,
    protected _injector: Injector,
    private _tramDoGiaTriDoService: TramDoGiaTriDoService,
    private _tramDoYeuToDoService: TramDoYeuToDoService,
  ) {
    super(null, _injector);
    this.tuNgay = new Date();
    this.tuNgay.setHours(0, 0, 0, 0)
    this.denNgay = new Date();
  }

  ngOnInit() {

    this.cols = [
      { field: 'thoiGianDo', header: this._translateService.instant('FORM.CODE'), visible: true, width: 'auto', },
      { field: 'gioPhutDo', header: this._translateService.instant('FORM.TITLE'), visible: true, width: 'auto', },
    ];

    this.getsMyTramDo();
    this._activatedRoute.params
      .pipe(map(params => params['id']), takeUntil(this._unsubscribeAll))
      .subscribe(async pid => {
        this.idTramDo = pid;

      });
    if (this.idTramDo !== undefined) {
      this.getDetail();
      this.getData();
    }
  }

  getDetail() {
    this.optionDmYeuTodo = [];
    this._tramDoService.getById(this.idTramDo).then(rs => {
      if (rs.success) {
        this.itemDetail = rs.data;
      }
    });
    this._tramDoYeuToDoService.getsByIdTramDo(this.idTramDo).then(rs => {
      if (rs.success) {
        this.listTramDoYeuToDo = rs.data;
        rs.data.forEach(item => {
          this.optionDmYeuTodo.push({ label: `${item.titleDmYeuToDo} (${item.codeDmYeuToDo})`, value: item.idDmYeuToDo })
        });
      }
    });
  }

  getData() {
    let searchModel = {
      idTramDo: this.idTramDo,
      tuNgay: this.tuNgay,
      denNgay: this.denNgay,
    }
    this._tramDoGiaTriDoService.find(searchModel).then(rs => {
      if (rs.success) {
        this.dataSource = rs.data;
        this.dataExport = rs.data;
      }
    });

  }
  exportExcel() {
    if (!this.monthReport) {
      this._notifierService.showWarning('Bạn chưa chọn tháng');
      return;
    }
    if (!this.idDmYeuToDo) {
      this._notifierService.showWarning('Bạn chưa chọn yếu tố đo');
      return;
    }
    var model = {
      idTramDo: this.idTramDo,
      idDmYeuToDo: this.idDmYeuToDo,
      monthReport: this.monthReport
    };

    this._tramDoGiaTriDoService.exportReportByMonth(model);
  }

  getDataMonth() {
    if (!this.monthReport) {
      this._notifierService.showWarning('Bạn chưa chọn tháng');
      return;
    }
    if (!this.idDmYeuToDo) {
      this._notifierService.showWarning('Bạn chưa chọn yếu tố đo');
      return;
    }
    var model = {
      idTramDo: this.idTramDo,
      idDmYeuToDo: this.idDmYeuToDo,
      monthReport: this.monthReport
    };
    var yeuToDoInfo = this.listTramDoYeuToDo.filter(x => x.idDmYeuToDo == this.idDmYeuToDo)[0];
    if (yeuToDoInfo.tinhTongGiaTriDoTrong60p) {
      this.cols1 = [
        { field: 'thoiGianDo', header: 'Ngày', visible: true, width: '100px', },
        { field: 'h0', header: '01h', visible: true, width: 'auto', },
        { field: 'h1', header: '02h', visible: true, width: 'auto', },
        { field: 'h2', header: '03h', visible: true, width: 'auto', },
        { field: 'h3', header: '04h', visible: true, width: 'auto', },
        { field: 'h4', header: '05h', visible: true, width: 'auto', },
        { field: 'h5', header: '06h', visible: true, width: 'auto', },
        { field: 'h6', header: '07h', visible: true, width: 'auto', },
        { field: 'h7', header: '08h', visible: true, width: 'auto', },
        { field: 'h8', header: '09h', visible: true, width: 'auto', },
        { field: 'h9', header: '10h', visible: true, width: 'auto', },
        { field: 'h10', header: '11h', visible: true, width: 'auto', },
        { field: 'h11', header: '12h', visible: true, width: 'auto', },
        { field: 'h12', header: '13h', visible: true, width: 'auto', },
        { field: 'h13', header: '14h', visible: true, width: 'auto', },
        { field: 'h14', header: '15h', visible: true, width: 'auto', },
        { field: 'h15', header: '16h', visible: true, width: 'auto', },
        { field: 'h16', header: '17h', visible: true, width: 'auto', },
        { field: 'h17', header: '18h', visible: true, width: 'auto', },
        { field: 'h18', header: '19h', visible: true, width: 'auto', },
        { field: 'h19', header: '20h', visible: true, width: 'auto', },
        { field: 'h20', header: '21h', visible: true, width: 'auto', },
        { field: 'h21', header: '22h', visible: true, width: 'auto', },
        { field: 'h22', header: '23h', visible: true, width: 'auto', },
        { field: 'h23', header: '24h', visible: true, width: 'auto', },
        { field: 'sumValue', header: 'Tổng', visible: true, width: 'auto', },
        { field: 'avgValue', header: 'TB', visible: true, width: 'auto', },
        { field: 'minValue', header: 'Min', visible: true, width: 'auto', },
        { field: 'maxValue', header: 'Max', visible: true, width: 'auto', },

      ];
    } else {
      this.cols1 = [
        { field: 'thoiGianDo', header: 'Ngày', visible: true, width: '100px', },
        { field: 'h0', header: '01h', visible: true, width: 'auto', },
        { field: 'h1', header: '02h', visible: true, width: 'auto', },
        { field: 'h2', header: '03h', visible: true, width: 'auto', },
        { field: 'h3', header: '04h', visible: true, width: 'auto', },
        { field: 'h4', header: '05h', visible: true, width: 'auto', },
        { field: 'h5', header: '06h', visible: true, width: 'auto', },
        { field: 'h6', header: '07h', visible: true, width: 'auto', },
        { field: 'h7', header: '08h', visible: true, width: 'auto', },
        { field: 'h8', header: '09h', visible: true, width: 'auto', },
        { field: 'h9', header: '10h', visible: true, width: 'auto', },
        { field: 'h10', header: '11h', visible: true, width: 'auto', },
        { field: 'h11', header: '12h', visible: true, width: 'auto', },
        { field: 'h12', header: '13h', visible: true, width: 'auto', },
        { field: 'h13', header: '14h', visible: true, width: 'auto', },
        { field: 'h14', header: '15h', visible: true, width: 'auto', },
        { field: 'h15', header: '16h', visible: true, width: 'auto', },
        { field: 'h16', header: '17h', visible: true, width: 'auto', },
        { field: 'h17', header: '18h', visible: true, width: 'auto', },
        { field: 'h18', header: '19h', visible: true, width: 'auto', },
        { field: 'h19', header: '20h', visible: true, width: 'auto', },
        { field: 'h20', header: '21h', visible: true, width: 'auto', },
        { field: 'h21', header: '22h', visible: true, width: 'auto', },
        { field: 'h22', header: '23h', visible: true, width: 'auto', },
        { field: 'h23', header: '24h', visible: true, width: 'auto', },
        { field: 'avgValue', header: 'TB', visible: true, width: 'auto', },
        { field: 'minValue', header: 'Min', visible: true, width: 'auto', },
        { field: 'maxValue', header: 'Max', visible: true, width: 'auto', },

      ];

    }




    this._tramDoGiaTriDoService.getsReportByMonth(model).then(rs => {
      if (rs.success) {
        this.dataSourceMonth = rs.data;
        this.dataExportMonth = rs.data;
      }
    })
  }
  exportExcelMonth() {
    if (!this.monthReport) {
      this._notifierService.showWarning('Bạn chưa chọn tháng');
      return;
    }
    if (!this.idDmYeuToDo) {
      this._notifierService.showWarning('Bạn chưa chọn yếu tố đo');
      return;
    }
    var model = {
      idTramDo: this.idTramDo,
      idDmYeuToDo: this.idDmYeuToDo,
      monthReport: this.monthReport
    };

    this._tramDoGiaTriDoService.exportReportByMonth(model);
  }

  getsMyTramDo() {
    this.listTramDo = [];
    this._tramDoService.getsMyTramDo().then((res) => {
      if (res.success) {
        this.convertDataToOptions(this.listTramDo, res.data, 'title');
        if (this.idTramDo == undefined) {
          this.idTramDo = res.data[0].id;
          this.getDetail();
          this.getData();
        }
      }
    });
  }

  onChangeTramDo() {
    this.idTramDo = this.selectedItem;
    this.getDetail();
    this.getData();
  }
  exportToExcel() {
    let timeSpan = new Date().toISOString();
    let prefix = "Dữ liệu đo";
    let fileName = `${prefix}-${timeSpan}`;
    let targetTableElm = document.getElementById("tblDataByDay");
    let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{ sheet: prefix });
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}

